module.exports = __webpack_public_path__ + "7f99163d6292539b4341320ad8843308.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/quarantaene.jpg
// module id = 636
// module chunks = 0